export const LOADING_TEXT = 'Loading program data...'
export const TAB_TITLE = 'Lessons'

export const MISSING_PRODUCT_ERROR = {
  errorStatus: 404,
  errorDetails:
    'Requested program was not found. Please check the url and try again.',
}

export const SELA_PRODUCT_NAMES = [
  'sel-for-adults',
  'sel-for-adults-field-test',
]

// Lessons landing paths
export const DWB_LESSONS_BASE_PATH = '/product/digital-well-being/lessons'
export const ELEMENTARY_LESSONS_LANDING_PATH = '/product/elementary/lessons'
export const MIDDLE_SCHOOL_LESSONS_LANDING_PATH =
  '/product/middle-school/lessons'

export const LESSONS_LANDING_ROUTES = [
  DWB_LESSONS_BASE_PATH,
  ELEMENTARY_LESSONS_LANDING_PATH,
  MIDDLE_SCHOOL_LESSONS_LANDING_PATH,
]

// Individual lesson and resource paths
export const DWB_PATH_TO_GRADE = `${DWB_LESSONS_BASE_PATH}/:verb(preview|teach)/:grade`
export const PROGRAM_SCOPED_DWB_PATH_TO_GRADE =
  '/product/:program(elementary|middle-school|high-school)/lessons/digital-well-being/:verb(preview|teach)/:grade'
export const DWB_PATH_TO_LE = `${DWB_LESSONS_BASE_PATH}/:verb(preview|teach)/:grade/:lesson`
export const PROGRAM_SCOPED_DWB_PATH_TO_LE =
  '/product/:program(elementary|middle-school|high-school)/lessons/digital-well-being/:verb(preview|teach)/:grade/:lesson'
export const DWB_PATH_TO_TRAINING =
  '/product/digital-well-being/training/:trainingSlug'
export const LESSON_PATH_TO_LE =
  '/product/:program(elementary|middle-school)/lessons/:verb(preview|teach)/:grade/:unit/:lesson(lesson-[^/]+)'
export const LEGACY_LESSON_RESOURCE_PATH =
  '/product/:program(elementary|middle-school|high-school)/lessons/:verb(preview|teach)/:grade/:unit/:resourceSlug'

export const INDIVIDUAL_RESOURCE_V3_ROUTES = [
  DWB_PATH_TO_TRAINING,
  DWB_PATH_TO_LE,
  PROGRAM_SCOPED_DWB_PATH_TO_LE,
  DWB_PATH_TO_GRADE,
  PROGRAM_SCOPED_DWB_PATH_TO_GRADE,
]
